import React from 'react'
import Col from 'react-bootstrap/Col';
import SecurePayLogo from "../assets/images/securepaylogo.png";

export default function Sidebar({ merchantDetails }) {
   

    return (
        <>
            <Col className="logo-container text-md-start text-center mobile-logo d-md-none">
                    <img src={merchantDetails.Logo ? merchantDetails.Logo : SecurePayLogo} className="merchant-logo" alt="merchant logo" />
            </Col>
            <Col md={4} sm={{ order: '1' }} xs={{ order: '2' }} className="pt-md-0 pt-4">
                <Col className="logo-container d-none d-md-block">
                        <img src={merchantDetails.Logo ? merchantDetails.Logo : SecurePayLogo} className="merchant-logo" alt="merchant logo" />
                </Col>

                {merchantDetails.BusinessName && <Col className="footer-merchant-name text-md-start text-center ">
                    <span>{merchantDetails.BusinessName}</span>
                </Col>}

                {merchantDetails.Address1 && <Col className="text-md-start text-center ">{merchantDetails.Address1}</Col>}
                {merchantDetails.Address2 && <Col className="text-md-start text-center ">{merchantDetails.Address2}</Col>}

                <Col className="text-md-start text-center ">{merchantDetails.City}, {merchantDetails.State} {merchantDetails.Zip}</Col>

                {merchantDetails.Phone && <Col className="phone text-md-start text-center">
                    <a href={`tel:+1${merchantDetails.Phone.slice(0,6)}-${merchantDetails.Phone.slice(6,10)}`}>{`(${merchantDetails.Phone.slice(0,3)})  ${merchantDetails.Phone.slice(3,6)}-${merchantDetails.Phone.slice(6,10)}`}</a>
                </Col>}

                {merchantDetails.Email && <Col className="text-md-start text-center">
                    <a href={`mailto:${merchantDetails.Email}`}>{merchantDetails.Email}</a>
                </Col>}

                {merchantDetails.Website && <Col className="text-md-start text-center">
                    <a href={ merchantDetails.Website && !merchantDetails.Website.startsWith('https://') && !merchantDetails.Website.startsWith('http://') ? 
                    `https://${merchantDetails.Website}` : merchantDetails.Website   }        
                    target="_blank" rel="noopener noreferrer">{merchantDetails.Website}</a>
                </Col>}
                <Col className="notes text-md-start text-center"></Col>
                
            </Col>
        </>
    )
}
